export function classNames(classObject) {
    const classNames = [];
    for (const item in classObject) {
        if (classObject[item]) {
            classNames.push(item);
        }
    }
    return classNames.join(' ');
}
